module.exports = __webpack_public_path__ + "media/images/icons/credit_card/discover-0bc53b551be1467dcbb5c8bc8a969ece.svg";